import React from 'react'

function Design() {
  return (
    <div>
        {/* <!-- Start Hero --> */}
    <section class="common-page-hero">
        <img src="assets/img/service/d13.png" class="common-hero-bg ak-bg" alt="..." />
        <div class="common-hero-content">
            <div class="common-hero-info">
                <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
                    <p class="ak-section-subtitle animation-title" > Courses</p>
                    <h2 class="ak-section-title animation-title" style={{fontSize:'45px'}}>
                    SEMANTIC Skills Junction: Bridging Talent and Technology
                    </h2>
                </div>
                <p class="back-btn"><a href="/">Home</a> / Course/ Design</p>
            </div>
            <a href="" class="phone-number">(+91) 7619617023</a>
        </div>
    </section>
    {/* <!-- End Hero --> */}

 
    <h2 class="ak-section-title animation-title" style={{fontSize:'35px',textAlign:'center'}}>
    ENABLE BUILDING QUALITY VLSI DESIGN TALENT
                    </h2>


                    
   
    <div class="container" style={{marginTop:'20px'}}>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-5">
            <a href="/Design" class="service-card style-two">
                <div class="service-thumb">
                    <img src="./assets/img/service/digic.png" alt="..." />
                    <div class="overlay-image">
                        <img src="./assets/img/service/digic.png" alt="..." />
                    </div>
                </div>
                <div class="service-info">
                    <p class="service-title">Digital IC Design<br/>(Front End Design)</p>
                   
                    <p class="service-desp">
                    <ul>
          <li>Specification Definition</li>
          <li>System Modelling</li>
          <li>RTL Design & Simulation</li>
          <li>Synthesis & Functional Verification</li>
          <li>Timing Analysis – STA (Static Timing Analysis)</li>
          <li>DFT – Design For Testability</li>
          <li>Netlist</li>
        </ul>
                    </p>
                </div>
                {/* <div class="service-footer">
                    <p class="more-btn">
                        <span> View More </span>
                        <span class="svg-icon style-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
                    </p>
                </div> */}
            </a>
            <a href="/Design" class="service-card style-two">
                <div class="service-thumb">
                    <img src="./assets/img/service/digb1.png" alt="..." />
                    <div class="overlay-image">
                        <img src="./assets/img/service/digb1.png" alt="..." />
                    </div>
                </div>
                <div class="service-info">
                    <p class="service-title">Digital IC Design <br/>(Back End Design)</p>
                    <p class="service-desp">
                    <ul>
          <li>Floor Planning / Placement / Power Planning </li>
          <li>Clock Tree Synthesis (CTS)</li>
          <li>Physical Verification & DFM (Design for Manufacturability)</li>
          <li>Netlist Extraction</li>
          <li>Post Layout Simulation & Verification</li>
          <li>GDSII Generation / Tape-out</li>
        </ul>
                    </p>
                </div>
                <div class="service-footer">
                    {/* <p class="more-btn">
                        <span> View More </span>
                        <span class="svg-icon style-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
                    </p> */}
                </div>
            </a>
            <a href="/Design" class="service-card style-two">
                <div class="service-thumb">
                    <img src="./assets/img/service/Ana.png" alt="..." />
                    <div class="overlay-image">
                        <img src="./assets/img/service/Ana.png" alt="..." />
                    </div>
                </div>
                <div class="service-info">
                    <p class="service-title">Analog IC Design</p>
                    <p class="service-desp">
                    <ul>
          <li>Specification Definition</li>
          <li>Architecture Design</li>
          <li>Behavioral Modeling</li>
          <li>Circuit Design</li>
          <li>Layout Design</li>
          <li>Pre- & Post-Layout Simulations</li>
          <li>GDSII Generation / Tape-out</li>
        </ul>
                    </p>
                </div>
                {/* <div class="service-footer">
                    <p class="more-btn">
                        <span> View More </span>
                        <span class="svg-icon style-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
                    </p>
                </div> */}
            </a>
            
            {/* <a href="service-details.html" class="service-card style-two">
                <div class="service-thumb">
                    <img src="./assets/img/service/s4.png" alt="..." />
                    <div class="overlay-image">
                        <img src="./assets/img/service/s4.png" alt="..." />
                    </div>
                </div>
                <div class="service-info">
                    <p class="service-title">NURTURING WAFER FAB, OSAT NEW HIRES</p>
                    <p class="service-desp">
                        This service involves creating customized financial plans tailored to the individual needs and goals of clients. Financial planning may.
                    </p>
                </div>
                <div class="service-footer">
                    <p class="more-btn">
                        <span> View More </span>
                        <span class="svg-icon style-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
                    </p>
                </div>
            </a> */}
            {/* <a href="service-details.html" class="service-card style-two mb-10">
                <div class="service-thumb">
                    <img src="./assets/img/service/s51.png" alt="..." />
                    <div class="overlay-image">
                        <img src="./assets/img/service/s51.png" alt="..." />
                    </div>
                </div>
                <div class="service-info">
                    <p class="service-title"> Digital IC Design</p>
                    <p class="service-desp">
                        This service involves creating customized financial plans tailored to the individual needs and goals of clients. Financial planning may.
                    </p>
                </div>
                <div class="service-footer">
                    <p class="more-btn">
                        <span> View More </span>
                        <span class="svg-icon style-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
                    </p>
                </div>
            </a> */}
            {/* <a href="service-details.html" class="service-card style-two">
                <div class="service-thumb">
                    <img src="./assets/img/service/s61.png" alt="..." />
                    <div class="overlay-image">
                        <img src="./assets/img/service/s61.png" alt="..." />
                    </div>
                </div>
                <div class="service-info">
                    <p class="service-title"> Analog IC Design</p>
                    <p class="service-desp">
                        This service involves creating customized financial plans tailored to the individual needs and goals of clients. Financial planning may.
                    </p>
                </div>
                <div class="service-footer">
                    <p class="more-btn">
                        <span> View More </span>
                        <span class="svg-icon style-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
                    </p>
                </div>
            </a> */}
        </div>
    </div>
  

        {/* <!-- Start Service Details --> */}
        {/* <div class="ak-height-75 ak-height-lg-50"></div> */}
    <section>
        <div class="container">
            <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
                <h3 class="ak-section-title animation-title" style={{fontSize:'40px'}}>
                Advancing IC Design Skills Through Comprehensive Training Programs
                </h3>
                <p class="ak-section-desp">
                <ul>
    <li>Most Finishing Schools or Campus Connect programs focus on select IC Design skills like PD, DV, and Analog layout due to volume demand.</li>
    <li>No existing campus programs cater to niche skills such as RTL Design, DFT, Analog Circuit Design, PDK Development, and Design Automation.</li>
    <li>This program addresses the gap by extending skill development to premium/niche areas.</li>
    <li>Enables students to work on "Spec to Silicon" projects in academia for complete exposure to the IC Development cycle.</li>
    <li>Resources and implementation are provided by top-class industry partners specializing in these functions.</li>
  </ul>
                </p>
            </div>
            <div class="ak-height-50 ak-height-lg-30"></div>
            {/* <!-- Start Images --> */}
            {/* <div class="content-image-container" style={{display: "flex"}}> */}
    {/* <div class="image-hov-one" style={{flex: "1"}}>
        <img class="img-fluid" src="assets/img/service/c1.png" alt="..." />
    </div>
    <div class="text-content" style={{flex: "1",marginLeft:'60px'}}>
        <p style={{margin: "0"}}>
            It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. 
            The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, 
            content here', making it look like readable English. It is a long established fact that a reader will be distracted by the 
            readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less 
            normal distribution.
        </p>
    </div> */}
{/* </div> */}
            <div class="image-hov-one" >
                <img class="img-fluid" src="assets/img/service/c1.png" alt="..." />
                
            </div>
            {/* <div class="ak-height-50 ak-height-lg-30"></div> */}
            <p>
            
            </p>
            {/* <!-- End Images --> */}
        </div>
    </section>
    {/* <!-- End Service Details --> */}
   
    {/* <!-- Start Feature --> */}
    <div class="ak-height-100 ak-height-lg-50"></div>
    <section class="container">
        <div class="feature-content gap-2">
            <div class="feature-card">
                <img class="feature-icon" src="assets/img/icon/ok-sign.svg" alt="..." />
                <div class="feature-body">
                    <h5 class="feature-title">Advanced Skill Training</h5>
                    <p class="feature-desp"style={{textAlign:'justify'}}>
                    While common IC design skills are widely covered, this program emphasizes advanced topics like DFT and analog circuit design.
                    </p>
                </div>
            </div>
            <div class="ak-feature-hr ak-h-100"></div>
            <div class="feature-card">
                <img class="feature-icon" src="assets/img/icon/ok-sign.svg" alt="..." />
                <div class="feature-body">
                    <h5 class="feature-title">Hands-On Learning</h5>
                    <p class="feature-desp" style={{textAlign:'justify'}}>
                    Existing campus programs often overlook niche skills. This initiative extends training to critical areas like DFT and analog circuit design.
                    </p>
                </div>
            </div>
            <div class="ak-feature-hr ak-h-100"></div>
            <div class="feature-card">
                <img class="feature-icon" src="assets/img/icon/ok-sign.svg" alt="..." />
                <div class="feature-body">
                    <h5 class="feature-title">Real-World Exposure
                    </h5>
                    <p class="feature-desp" style={{textAlign:'justify'}}>
                    Students engage in gaining real-world insights and skills from industry experts in advanced IC design areas.
                    </p>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- End Feature --> */}
    <span class="ak-scrollup">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z"
          fill="currentColor"
        />
      </svg>
    </span>
    </div>
  )
}

export default Design
